/* Borderline winter 26/27 · content pages and articles (R7, 2026-10-21): marks the in-page contents link of the
   section being read (aria-current="true" on .blc-toc links; the style is in bl-content.css). The links work without
   it. Scroll events are read on the document in the capture phase: from 990 up Horizon scrolls .page-wrapper, not the
   window. One pass per animation frame; nothing runs when the page has no contents. */

const READ_LINE = 0.3; // a section counts as being read once its heading passes 30% of the window's height

function init(toc) {
  const links = [...toc.querySelectorAll('a[href^="#"]')];
  const pairs = links
    .map((link) => {
      let id = '';
      try {
        id = decodeURIComponent(link.hash.slice(1));
      } catch (e) {
        id = link.hash.slice(1);
      }
      const target = id ? document.getElementById(id) : null;
      return target ? { link, target } : null;
    })
    .filter(Boolean);
  if (!pairs.length) return;

  let current = null;
  let queued = false;

  const update = () => {
    queued = false;
    const line = window.innerHeight * READ_LINE;
    let next = pairs[0];
    for (const pair of pairs) {
      if (pair.target.getBoundingClientRect().top - line <= 0) next = pair;
      else break;
    }
    if (next === current) return;
    if (current) current.link.removeAttribute('aria-current');
    next.link.setAttribute('aria-current', 'true');
    current = next;
  };

  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  document.addEventListener('scroll', queue, { capture: true, passive: true });
  window.addEventListener('resize', queue, { passive: true });
  update();
}

for (const toc of document.querySelectorAll('.blc-toc')) init(toc);
